import clsx from "clsx"
import { type ReactElement, memo } from "react"
import { Card } from "@/ui/Card"
import { type IGoldCardList } from "./types"

export const GoldCardList = memo(function GoldCardList({
  items,
  isMatchActive
}: IGoldCardList): ReactElement[] {
  return items.map((el, i) => {
    const index = Math.min(i, 3)

    return (
      <Card
        {...el}
        dataFlipId={`card-${el.id}`}
        className={clsx("box", el.status)}
        style={{
          transform: `translateX(-${index * 5}%) translateY(-${index * 0.5}%)`
        }}
        isShowFrontSide={false}
        isMatchActive={isMatchActive}
        key={`card-${el.id}`}
      >
        {el.id}
      </Card>
    )
  })
})
